enum DATE_RANGE_CONFIG_KEY {
    lastWeek = 'lastWeek',
    lastMonth = 'lastMonth',
}

type DateRangeConfig = {
    label: string;
    key: DATE_RANGE_CONFIG_KEY;
};

type DateRange = {
    start: Date;
    end: Date;
};

export { DATE_RANGE_CONFIG_KEY, DateRangeConfig, DateRange };
